import { buscarVersoesdaPrevia } from './api-planejamento-tributario.service';
import { normalizarVersoes } from '../utils/versoes.utils';
import { versoesStatusService } from './versoesStatus.service';

/**
 * Serviço para operações relacionadas a versões
 */
class VersoesOperationsService {
  /**
   * Busca e normaliza versões de uma prévia
   */
  async buscarVersoesNormalizadas(tipoPrevia, idPrevia) {
    try {
      if (tipoPrevia === 'PIS-COFINS') {
        const { listarVersoesPreviaPisCofins } = await import('./api-piscofins.service');
        const response = await listarVersoesPreviaPisCofins(idPrevia);
        
        // O backend agora retorna { previa, versoes }
        // Se retornar array direto (legado), mantemos compatibilidade
        const listaVersoes = Array.isArray(response) ? response : (response.versoes || []);
        
        // Podemos salvar a prévia se necessário, ou retornar junto
        // Por enquanto, o ModalVersoes espera um array de versões normalizadas
        // Mas podemos anexar a prévia ao array ou retornar um objeto se mudarmos a assinatura
        // Para manter compatibilidade com o hook, vamos retornar as versões, mas anexar a prévia na primeira versão ou retornar um objeto estendido
        
        // Estratégia: Normalizar versões. Se houver dados da prévia, o chamador (Modal) deve lidar
        // ATENÇÃO: O ModalVersoes chama este serviço. Vamos alterar para retornar o objeto completo se for o caso?
        // O método se chama 'buscarVersoesNormalizadas'. Espera-se que retorne versões.
        
        // Vamos anexar a 'previa' como uma propriedade estática no array de resultado para acesso fácil sem quebrar quem espera array
        const versoesNormalizadas = normalizarVersoes(listaVersoes);
        
        if (response.previa) {
          versoesNormalizadas.dadosPrevia = response.previa;
        }
        
        return versoesNormalizadas;
      } else {
        const response = await buscarVersoesdaPrevia(tipoPrevia, idPrevia);
        return normalizarVersoes(response.versoes || response || []);
      }
    } catch (error) {
      console.error('[VersoesOperationsService] Erro ao buscar versões:', error);
      throw error;
    }
  }

  /**
   * Inicia acompanhamento de uma nova versão criada
   */
  async iniciarAcompanhamentoNovaVersao(versaoId, onVersaoAdicionada) {
    try {
      // Aguardar um pouco para garantir que o status foi registrado no Redis
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const status = await versoesStatusService.buscarStatus(versaoId);
      
      // Iniciar polling se versão está ativa
      if (status && versoesStatusService.isVersaoAtiva(status)) {
        if (onVersaoAdicionada) {
          onVersaoAdicionada(versaoId, status);
        }
        return status;
      }
      
      return null;
    } catch (error) {
      console.error('[VersoesOperationsService] Erro ao iniciar acompanhamento:', error);
      // Mesmo com erro, tentar iniciar polling (pode estar aguardando)
      if (onVersaoAdicionada) {
        onVersaoAdicionada(versaoId, null);
      }
      return null;
    }
  }
}

export const versoesOperationsService = new VersoesOperationsService();
export default VersoesOperationsService;

